export default __webpack_public_path__ + "static/media/Facebook.ccefe184.png";